import React, { ReactNode } from 'react';

import classes from 'components/common/NoData/noData.module.scss';

type Props = {
    className?: string;
    children?: ReactNode;
};

export const noDataMessage = 'No results found for the applied filter.';

const NoData = ({ children, className }: Props) => {
    return (
        <div className={`${classes.wrapper} ${className ?? ''}`} data-testid={'wrapper'}>
            {children ?? noDataMessage}
        </div>
    );
};

export default NoData;
